/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try WordCraft online on this page, or download it for Windows, Mac and Linux. Find beginner guides and compare this free editor with Microsoft Word.`)
};

/**
* | output |
* | --- |
* | "Try WordCraft online on this page, or download it for Windows, Mac and Linux. Find beginner guides and compare this free editor with Microsoft Word." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }